import script from "./EdgePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./EdgePanel.vue?vue&type=script&setup=true&lang=js"

import "./EdgePanel.vue?vue&type=style&index=0&id=74834556&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74834556"]])

export default __exports__